let initialized = false;

function updatePanelCarousels(panel) {
    panel.querySelectorAll('.swiper').forEach((carousel) => {
        if (!carousel.swiper) {
            return;
        }

        carousel.swiper.update();
    });

    if (typeof window.calculateProductHeight === 'function') {
        window.requestAnimationFrame(() => window.calculateProductHeight());
    }
}

function handleTabClick(event) {
    const tab = event.target.closest('.product-list-tabs .tabs__nav-item');

    if (!tab) {
        return;
    }

    const container = tab.closest('.product-list-tabs');
    const panel_id = tab.dataset.list;
    const panel = panel_id ? document.getElementById(panel_id) : null;

    if (!container || !panel || !container.contains(panel)) {
        return;
    }

    event.preventDefault();

    container.querySelectorAll('.tabs__nav-item').forEach((item) => {
        item.classList.remove('js-active');
    });

    container.querySelectorAll('.tab__panel').forEach((item) => {
        item.classList.remove('js-active');
    });

    tab.classList.add('js-active');
    panel.classList.add('js-active');

    window.requestAnimationFrame(() => updatePanelCarousels(panel));
}

/**
 * Inicializa a navegação das listas de produtos em abas.
 */
export function initProductListTabs() {
    if (initialized || !document.querySelector('.product-list-tabs')) {
        return;
    }

    document.addEventListener('click', handleTabClick);
    initialized = true;
}
